import { cdnTemplate, jadeLocals } from 'cdnPreprocessor';

const ANIMATION_LENGTH = 5.5;
const FULL_HEIGHT = 630;
const MUG_TOP_PERCENT = 21.4;
const MUG_BOTTOM_PERCENT = 76.2;
const MUG_HEIGHT_PERCENT = 54.8;
const DRAG_HANDLE_HEIGHT = 55;

const COLD = { r: 24, g: 127, b: 255 },
  MID = { r: 255, g: 198, b: 0 },
  HOT = { r: 255, g: 0, b: 0 };

function lerp(min, max, value) {
  return min * (1 - value) + max * value;
}

function inverseLerp(min, max, value) {
  return (value - min) / (max - min);
}

export default ['$window', '$timeout', function ProductColorTransition($window, $timeout) {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      product: '=',
      view: '&'
    },
    template: require('./product-color-transition.jade')(jadeLocals),
    link: (scope, el) => {
      let $el = $(el),
        $handle = $el.find('.demo-handle'),
        $targets = $el.find('.color-target'),
        $mug = $el.find('canvas#display'),
        $img = $el.find('img.design.front'),
        $mask = $el.find('img.mask.front');

      let canvas = $mug.get(0),
        ctx = canvas.getContext('2d'),
        images = {
          grade: $el.find('img.mask.gradient').get(0),
          front: $img.get(0),
          back: $el.find('img.design.back').get(0),
          coldFront: $mask.get(0),
          coldBack: $el.find('img.mask.back').get(0)
        };

      let animating = false;
      scope.dragging = false;
      scope.heatLevel = 'fa-thermometer-4';
      $handle.css({ backgroundColor: `rgb(${HOT.r}, ${HOT.g}, ${HOT.b})` });

      function updateTransition(e, y) {
        if (typeof e != 'undefined' && e != null) e.preventDefault();

        let mugTop = $mug.offset().top, //55
          mugBottom = mugTop + $mug.height(), //630
          handleTop = mugTop + 25,
          handleBottom = mugBottom * 0.82,
          dragPercent = ((y - mugTop) / $mug.height()) * 100

        // Inside bounds.
        if (y > mugTop && y < mugBottom) {

          if (dragPercent < MUG_TOP_PERCENT) dragPercent = MUG_TOP_PERCENT;
          else if (dragPercent > MUG_BOTTOM_PERCENT) dragPercent = MUG_BOTTOM_PERCENT;
          if (!animating) $handle.css({ top: `${dragPercent}%`, transform: 'translateY(-50%)' }); // Only update the handle position if we're not animating it ourselves.

          let bottom = mugBottom - mugTop,
            percent = ((y - mugTop) / bottom), // roughly clamped between 10% and 80% by the above checking
            lerpPercent = (dragPercent - MUG_TOP_PERCENT) / (MUG_BOTTOM_PERCENT - MUG_TOP_PERCENT),
            proportion = inverseLerp(9, 81, lerpPercent * 100),
            gradeOffset = (percent * FULL_HEIGHT) - FULL_HEIGHT,
            gradientPercent = ((Math.abs(gradeOffset) / FULL_HEIGHT) - .205) / (.836 - .205),
            topGradientTransition = (DRAG_HANDLE_HEIGHT / 1.5) * ((gradientPercent - .5) - 0) / (.5 - 0),
            bottomGradientTransition = (DRAG_HANDLE_HEIGHT / 2) * (gradientPercent - .5) / (0 - .5);

          gradeOffset = gradientPercent > .5 ? gradeOffset - topGradientTransition : gradeOffset + bottomGradientTransition;

          let design = scope.view() == 'front' ? images.front : images.back,
            cold = scope.view() == 'front' ? images.coldFront : images.coldBack;

          // Render canvas.
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.globalCompositeOperation = 'source-over';
          ctx.drawImage(cold, 0, 0, 530, 630);
          ctx.globalCompositeOperation = 'destination-in';
          ctx.drawImage(images.grade, 0, gradeOffset, 530, 1260);
          ctx.globalCompositeOperation = 'destination-over';
          ctx.drawImage(design, 0, 0, 530, 630);

          // Thermometer icon.
          if (proportion < 0.2) scope.heatLevel = 'fa-thermometer-4';
          else if (proportion < 0.4) scope.heatLevel = 'fa-thermometer-3';
          else if (proportion < 0.6) scope.heatLevel = 'fa-thermometer-2';
          else if (proportion < 0.8) scope.heatLevel = 'fa-thermometer-1';
          else scope.heatLevel = 'fa-thermometer-0';

          // Color interpolation.
          let r, g, b, midProp;
          if (proportion < 0.5) { // Warm half
            midProp = inverseLerp(0, 0.5, proportion);
            r = lerp(HOT.r, MID.r, midProp);
            g = lerp(HOT.g, MID.g, midProp);
            b = lerp(HOT.b, MID.b, midProp);
          } else { // Cold half
            midProp = inverseLerp(0.5, 1, proportion);
            r = lerp(MID.r, COLD.r, midProp);
            g = lerp(MID.g, COLD.g, midProp);
            b = lerp(MID.b, COLD.b, midProp);
          }
          r = Math.floor(r);
          g = Math.floor(g);
          b = Math.floor(b);
          let newColor = `rgb(${r}, ${g}, ${b})`;
          $handle.css({ backgroundColor: newColor });
          $targets.css({ color: newColor });
        }
      }

      // Only resize to fit once the image has loaded.
      $img.one('load', () => updateTransition(null, $handle.offset().top + (DRAG_HANDLE_HEIGHT / 2)));
      scope.$watch(() => scope.view(), (v) => {
        // Empty timeout so our digest cycle finishes and the new svg renders properly.
        $timeout(() => updateTransition(null, $handle.offset().top + (DRAG_HANDLE_HEIGHT / 2)));
      });

      let lockFrame = false;

      scope.move = (e) => {
        if (lockFrame || !scope.dragging) return;
        lockFrame = true;
        let position = e.pageY || e.originalEvent.touches[0].pageY;
        $window.requestAnimationFrame(() => {
          updateTransition(e, position);
          lockFrame = false;
        });
      }

      scope.moved = (e) => {
        scope.dragging = false;
      }

      scope.startMove = (e) => {
        scope.dragging = true;
        e.preventDefault();
      }

      $el.on('touchmove', scope.move).on('touchend', scope.moved);
      $handle.on('touchstart', scope.startMove);
      $($window).on('resize', () => {
        updateTransition(null, $handle.offset().top + (DRAG_HANDLE_HEIGHT / 2));
      });
      $($window).on('mouseup', scope.moved);

      // Opening Animation
      animating = true;
      let start = null,
        finished = false;

      function pageLoadAnimation(timestamp) {
        if (scope.dragging) { // if the user starts dragging - stop immediately
          animating = false;
          return;
        }

        if (start === null) start = timestamp;
        let elapsed = timestamp - start,
          progress = elapsed / (ANIMATION_LENGTH * 1000),
          clampCos = Math.abs((((Math.cos(progress * 2 * Math.PI) / 2 + (1 / 2)) * 100) - 100));
        $handle.css({ top: `${((MUG_HEIGHT_PERCENT / 100) * clampCos) + MUG_TOP_PERCENT}%`, transform: 'translateY(-50%)' });

        let handleOffset = (((DRAG_HANDLE_HEIGHT / 2) / 100) * clampCos) + (DRAG_HANDLE_HEIGHT / 5);

        updateTransition(null, $handle.offset().top + handleOffset);
        if (progress < 1) {
          $window.requestAnimationFrame(pageLoadAnimation);
        } else {
          animating = false;
        }
      }
      $window.requestAnimationFrame(pageLoadAnimation);

      scope.$on('$destroy', () => {
        $el.off();
        $handle.off();
        $($window).off('resize');
        $($window).off('mouseup')
      });
    }
  }
}];


// WEBPACK FOOTER //
// ./source/client/pages/store/product-color-transition/product-color-transition.dir.js